import { Icon } from "./Icon.js";

/**
 * One line of feedback, in one of three tones. Rendered as text, never as
 * markup: some of these sentences come from the worker.
 *
 * Errors stay inline, next to what failed. A plain success ("Saved.") is a
 * toast instead (`Toast.tsx`), because it needs no action and should not push
 * the layout around.
 */
export function Notice({ tone, children }: { tone: "error" | "ok" | "warn"; children: string }) {
  return (
    <p className={`notice notice-${tone}`} role={tone === "error" ? "alert" : "status"}>
      <Icon name={tone === "ok" ? "check-circle" : "alert"} size={18} />
      <span>{children}</span>
    </p>
  );
}
